class HeroSlider {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.hero-slide'));
    this.dots = Array.from(el.querySelectorAll('.hero-slider__dot'));
    this.current = 0;
    this.interval = parseInt(el.dataset.autoplay, 10) || 3000;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.restart();
      });
    });

    // Pause on hover / focus for accessibility
    el.addEventListener('mouseenter', () => this.stop());
    el.addEventListener('mouseleave', () => this.restart());
    el.addEventListener('focusin', () => this.stop());
    el.addEventListener('focusout', () => this.restart());

    this.start();
  }

  goTo(index) {
    this.slides[this.current].classList.remove('is-active');
    if (this.dots[this.current]) this.dots[this.current].classList.remove('is-active');

    this.current = index;

    this.slides[this.current].classList.add('is-active');
    if (this.dots[this.current]) this.dots[this.current].classList.add('is-active');
  }

  next() {
    const nextIndex = (this.current + 1) % this.slides.length;
    this.goTo(nextIndex);
  }

  start() {
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stop() {
    clearInterval(this.timer);
  }

  restart() {
    this.stop();
    this.start();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hero-slider').forEach((el) => new HeroSlider(el));
});